import React from 'react';
import { ChevronDown } from 'lucide-react';

type FilterSelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

const FilterSelect: React.FC<FilterSelectProps> = ({ className = '', children, ...props }) => {
    return (
        <div className="relative">
            <select
                {...props}
                className={`select-custom-icon appearance-none border border-gray-300 rounded-md py-2 pl-3 pr-10 text-sm focus:ring-indigo-500 focus:border-indigo-500 bg-white ${className}`}
            >
                {children}
            </select>
            <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        </div>
    );
};

export default FilterSelect;
